import {RestApiService} from "../rest-api.service";
import {ApiV0Auth} from "./v0/api.v0.auth";
import {ApiV0Manage} from "./v0/cp/api.v0.manage";
import {ApiV0Company} from "./v0/Core/api.v0.company";
import {ApiV0CompanyV3} from "./v0/Core/api.v0.company.v3";
import {ApiV0Products} from './v0/Core/api.v0.products';
import {ApiV0News} from './v0/cp/api.v0.news';
import {ApiV0Accounts} from './v0/Core/api.v0.accounts';
import {ApiV0Misc} from './v0/Core/api.v0.misc';
import {ApiV0License} from './v0/cp/api.v0.license';
import {ApiV0File} from './v0/cp/api.v0.file';
import {ApiV0Version} from './v0/api.v0.version';
import {ApiV0Crm} from './v0/api.v0.crm';
import {ApiV0Fibu} from './v0/api.v0.fibu';
import {ApiV0Invoice} from './v0/cp/api.v0.invoice';
import {ApiV0Offer} from './v0/cp/api.v0.offer';
import {ApiV0BillingTextTemplate} from './v0/cp/api.v0.billing-text-template';
import {ApiV0ResourceManager} from './v0/api.v0.resource-manager';
// update starts here
import {ApiV0Contracting} from './v0/api.v0.contracting';
import {ApiV0Inventory} from './v0/api.v0.inventory';
// update ends here
import {CookieService} from 'ngx-cookie-service';
import {ApiV0EntityMapping} from './v0/entity-mapping/api.v0.entity.mapping';
import {ApiV0Administration} from './v0/api.v0.administration';
import {ApiV0ExcelTemplate} from './v0/cp/api.v0.ExcelTemplate';
import {ApiV0Tickets} from './v0/cp/api.v0.tickets';
import {ApiV0BankAccount} from './v0/cp/api.v0.bankAccount';
import {ApiV0Notifications} from './v0/cp/api.v0.notifications';
import {ApiV0AdminRoleV3} from './v0/administration/api.v0.admin.role.v3';

export class ApiV0 {

    segment: string;
    crmSegment: string

    constructor(
        api: RestApiService,
        private cookieService: CookieService
    ) {
        this.segment = api.host + '/v0';
        this.crmSegment = this.segment + '/CRM'
        this.administration = new ApiV0Administration(this, api);
        this.auth = new ApiV0Auth(this, api);
        this.accounts = new ApiV0Accounts(this, api);
        this.manage = new ApiV0Manage(this, api);
        this.company = new ApiV0Company(this, api);
        this.companyV3 = new ApiV0CompanyV3(this.company);
        this.products = new ApiV0Products(this, api);
        this.news = new ApiV0News(this, api);
        this.misc = new ApiV0Misc(this, api);
        this.license = new ApiV0License(this, api);
        this.file = new ApiV0File(this, api);
        this.version = new ApiV0Version(this, api);
        this.crm = new ApiV0Crm(this, api);
        this.fibu = new ApiV0Fibu(this, api, this.cookieService);
        this.invoice = new ApiV0Invoice(this, api);
        this.offer = new ApiV0Offer(this, api);
        this.billingTextTemplates = new ApiV0BillingTextTemplate(this, api);
        this.excelImport = new ApiV0ExcelTemplate(this, api);
        this.tickets = new ApiV0Tickets(this, api);
        this.resourceManager = new ApiV0ResourceManager(this, api);
        this.entityMapping = new ApiV0EntityMapping(this, api); // PMP
        // update starts here
        this.contracting = new ApiV0Contracting(this, api);
        this.inventory = new ApiV0Inventory(this, api);
        // update ends here
        this.bankAccounts = new ApiV0BankAccount(this, api)
        this.notifications = new ApiV0Notifications(this, api)
    }

    public readonly auth: ApiV0Auth;
    public readonly accounts: ApiV0Accounts;
    public readonly administration: ApiV0Administration;
    public readonly manage: ApiV0Manage;
    public readonly company: ApiV0Company;
    public readonly companyV3: ApiV0CompanyV3;
    public readonly products: ApiV0Products;
    public readonly news: ApiV0News;
    public readonly misc: ApiV0Misc;
    public readonly license: ApiV0License;
    public readonly tickets: ApiV0Tickets;
    public readonly file: ApiV0File;
    public readonly version: ApiV0Version;
    public readonly crm: ApiV0Crm;
    public readonly fibu: ApiV0Fibu;
    public readonly invoice: ApiV0Invoice;
    public readonly offer: ApiV0Offer;
    public readonly billingTextTemplates: ApiV0BillingTextTemplate;
    public readonly excelImport: ApiV0ExcelTemplate;
    public readonly resourceManager: ApiV0ResourceManager;
    public readonly entityMapping: ApiV0EntityMapping; // PMP
    // update starts here
    public readonly contracting: ApiV0Contracting;
    public readonly inventory: ApiV0Inventory;
    // update ends here
    public readonly bankAccounts: ApiV0BankAccount;
    public readonly notifications: ApiV0Notifications;
}
